import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-close-button',
  standalone: true,
  imports: [MatButtonModule, MatIconModule],
  template: `
    <button
      mat-icon-button
      type="button"
      [style.backgroundColor]="backgroundColor()"
      [class.close-button]="true"
      (click)="hasChanges() ? confirmClosed.emit() : closed.emit()"
    >
      <mat-icon>close</mat-icon>
    </button>
  `,
  styles: `
    @use 'spacing/spacing-variables' as *;

    .close-button {
      position: absolute;
      right: $spacing-sm;
      top: $spacing-sm;
      border-radius: 100%;
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CloseButtonComponent {
  hasChanges = input<boolean>();
  closed = output<void>();
  confirmClosed = output<void>();
  backgroundColor = input<string>('transparent');
}
